import { comparisonContent } from '@/mocks/content';

export default function ComparisonTable() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.15em] mb-3">Confronto</p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-[1.12]">
            {comparisonContent.title}
          </h2>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/60">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-background-100/80">
                  <th className="px-5 md:px-7 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">
                    Caratteristica
                  </th>
                  <th className="px-5 md:px-7 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">
                    <span className="flex items-center gap-2">
                      <i className="ri-star-fill text-sm"></i>
                      Itaobuy Spreadsheet
                    </span>
                  </th>
                  <th className="px-5 md:px-7 py-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">
                    Ricerca manuale
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisonContent.rows.map((row, i) => (
                  <tr
                    key={i}
                    className={`border-t border-background-200/40 transition-colors ${
                      i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/30'
                    }`}
                  >
                    <td className="px-5 md:px-7 py-3.5 text-sm font-medium text-foreground-700">
                      {row.feature}
                    </td>
                    <td className="px-5 md:px-7 py-3.5 text-sm text-foreground-800">
                      {typeof row.spreadsheet === 'boolean' ? (
                        row.spreadsheet ? (
                          <span className="inline-flex items-center gap-1.5 text-accent-600 font-medium">
                            <i className="ri-check-line text-base"></i>
                            <span className="hidden sm:inline">Sì</span>
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1.5 text-foreground-300">
                            <i className="ri-close-line text-base"></i>
                          </span>
                        )
                      ) : (
                        <span className="font-medium text-foreground-800">{row.spreadsheet}</span>
                      )}
                    </td>
                    <td className="px-5 md:px-7 py-3.5 text-sm text-foreground-500">
                      {typeof row.traditional === 'boolean' ? (
                        row.traditional ? (
                          <span className="inline-flex items-center gap-1.5 text-accent-600 font-medium">
                            <i className="ri-check-line text-base"></i>
                            <span className="hidden sm:inline">Sì</span>
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1.5 text-foreground-300">
                            <i className="ri-close-line text-base"></i>
                            <span className="hidden sm:inline">No</span>
                          </span>
                        )
                      ) : (
                        <span>{row.traditional}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}